module.exports = __webpack_public_path__ + "static/main3-en-9e0072efd66014bb2cf00f867f66d1f6.png";